module.exports = __webpack_public_path__ + "img/17.bbad2e22.png";